import {TPMEventBO} from "./TPMEventBO";
import * as _ from 'lodash'
import {
  PaymentMethod_OffInvoice,
  Product_RowType_Consumer,
  Product_RowType_Display,
  Product_RowType_Finished
} from "../PA.TPM.Core/TPM.Constants";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {WB_FinishedProductRow, WB_TPM_EventSpendTypeRow, WB_WorkflowStatusRow} from "../PA.Core/PAdbSchemaRows";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {Message_restate} from "../PA.Core/Basic/MessageUtils";
import {ITPMEventSpend} from "../PA.TPM.Core/PA.TPM.IF.TPM.EventSpend.Aspects";

export interface IHaveSpendHistory {
  readonly SpendInitialState: ITPMSpendState
}

export interface ITPMSpendState {
  [id:number]: ITPMSpendStateNode
}

export interface ITPMSpendStateNode {
  WB_TEVTS_ID: number,
  EVENT_SPEND_ID: string,
  EVENT_SPEND_NAME:string,
  SpendType: WB_TPM_EventSpendTypeRow,
  ActualState: WB_WorkflowStatusRow,

  Rate_Amt: number,
  Rate_Basis: string,
  Rate_UOM: string,
  Payment_Method: string,

  InStore_Start_Dt: Date,
  InStore_End_Dt: Date,
  Shipment_Start_Dt: Date,
  Shipment_End_Dt: Date,
  Order_Start_Dt: Date,
  Order_End_Dt: Date,

  Included_ProductGroups: number[],
  Included_Products: number[]
  Included_Consumer_Products: number[],
  Included_Finished_Products: number[],
  Included_Display_Products: number[],

  ProductGroupProperties: {[id:number]: {
    Rate_Amt: number
    }}

  ProductProperties: {[id:number]: {
      Rate_Amt: number
    }}

  PLANNED_SPEND: number,
  ACTUAL_SPEND: number,
  APPROVED_SPEND: number
}


export function SpendHistory_get(bo: TPMEventBO): ITPMSpendState {
  let returnValue: ITPMSpendState = {}
  _.forEach(bo.TPMEventSpends, (aSpend) => {
    let aNode = SpendHistory_getBySpend(aSpend)
    returnValue[aNode.WB_TEVTS_ID] = aNode
  })

  return returnValue
}

export function SpendHistory_getBySpend(aSpend: ITPMEventSpend): ITPMSpendStateNode {
  let spnd = aSpend.TPMEventSpendRow
  let includedPGRows = _.filter(spnd.WB_TPM_EventSpendPrdGrpRows, (aRow) => aRow.isActive && aRow.cif.INCLUDE_IND === '1')
  let includedPrdRows = _.filter(spnd.WB_TPM_EventSpendPrdRows, (aRow) => aRow.isActive && aRow.cif.INCLUDE_IND === '1')

  let aNode: ITPMSpendStateNode = {
    WB_TEVTS_ID: spnd.cif.WB_TEVTS_ID,
    EVENT_SPEND_ID: spnd.cif.EVENT_SPEND_ID,
    EVENT_SPEND_NAME: spnd.cif.EVENT_SPEND_NAME,
    SpendType: spnd.WB_TPM_EventSpendTypeRow,
    ActualState: spnd.WB_WorkflowStatusRow,
    Rate_Amt: _.toNumber(spnd.cif.RATE_AMT),
    Rate_Basis: spnd.cif.RATE_BASIS_ID,
    Rate_UOM: spnd.cif.RATE_UOM,
    Payment_Method: spnd.cif.PAYMENT_METHOD,

    InStore_Start_Dt: _.clone(spnd.InStoreStartDt),
    InStore_End_Dt: _.clone(spnd.InStoreEndDt),
    Shipment_Start_Dt: _.clone(spnd.ShipmentStartDt),
    Shipment_End_Dt: _.clone(spnd.ShipmentEndDt),
    Order_Start_Dt: _.clone(spnd.OrderStartDt),
    Order_End_Dt: _.clone(spnd.OrderEndDt),

    Included_ProductGroups: _.map(includedPGRows, (aRow) => aRow.cif.WB_PRDGRP_ID),
    ProductGroupProperties: {},
    Included_Products: _.map(includedPrdRows,(aRow) => aRow.cif.WB_PROD_ID),
    Included_Consumer_Products: _.map(_.filter(includedPrdRows, (aRow) => aRow.cif.ROW_TYPE === Product_RowType_Consumer), (aRow) => aRow.cif.WB_PROD_ID),
    Included_Finished_Products: _.map(_.filter(includedPrdRows, (aRow) => aRow.cif.ROW_TYPE === Product_RowType_Finished), (aRow) => aRow.cif.WB_PROD_ID),
    Included_Display_Products: _.map(_.filter(includedPrdRows, (aRow) => aRow.cif.ROW_TYPE === Product_RowType_Display), (aRow) => aRow.cif.WB_PROD_ID),
    ProductProperties: {},

    PLANNED_SPEND: _.toNumber(spnd.cif.PLANNED_SPEND),
    APPROVED_SPEND: _.toNumber(spnd.cif.APPROVED_SPEND),
    ACTUAL_SPEND: _.toNumber(spnd.cif.ACTUAL_SPEND)
  }

  if(aNode.SpendType.cif.RATE_LEVEL == 'ProductGroup') {
    _.forEach(includedPGRows, (aPGRow) => {
      aNode.ProductGroupProperties[aPGRow.cif.WB_PRDGRP_ID] = {Rate_Amt: _.toNumber(aPGRow.cif.RATE_AMT)}
    })
  }

  if(aNode.SpendType.cif.RATE_LEVEL == 'Product') {
    _.forEach(includedPrdRows, (aPrdRow) => {
      aNode.ProductProperties[aPrdRow.cif.WB_PROD_ID] = {Rate_Amt: _.toNumber(aPrdRow.cif.RATE_AMT)}
    })
  }

  return aNode
}